// extracted by mini-css-extract-plugin
module.exports = {"titleGradient":"_2k93r","red":"_1JiSL","green":"_3ZXM8","blue":"ErAzC","purple":"_3efKd"};